import { createContext, useContext } from 'react';

export type NoticeVariant = 'info' | 'warning' | 'danger';

export interface NoticeContextValue {
  variant: NoticeVariant;
}

export const NoticeContext = createContext<NoticeContextValue | null>(null);

/** Lets sub-components read the variant without it being threaded down. */
export function useNoticeContext(): NoticeContextValue {
  const context = useContext(NoticeContext);

  if (!context) {
    throw new Error(
      'Notice sub-components must be rendered inside a <Notice>.'
    );
  }

  return context;
}
